import { useQuery, useQueryClient } from '@tanstack/react-query';
import type { Me, SessionState } from '@hoopify/shared';
import { api } from './api';

export const sessionKey = ['session'] as const;

export function useSession() {
  return useQuery({ queryKey: sessionKey, queryFn: () => api.get<SessionState>('/auth/session'), staleTime: 60_000 });
}

/** The signed-in user. Only use inside the signed-in part of the app. */
export function useMe(): Me {
  const { data } = useSession();
  if (data?.status !== 'signed_in') throw new Error('useMe used outside the signed-in app');
  return data.user;
}

export function useSetSession() {
  const qc = useQueryClient();
  return (state: SessionState) => {
    if (state.status !== 'signed_in') qc.removeQueries({ predicate: (q) => q.queryKey[0] !== 'session' });
    qc.setQueryData(sessionKey, state);
  };
}
